<template>
<div>
    <div class="title">资讯中心<span></span></div>
    <div class="gongx">
      <h3>{{li.title}}</h3>
      <p>发布时间：{{li.addtime}}</p>
      <div style="line-height:30px" v-html="li.content">
         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{li.content}}
      </div>
    </div>
</div>
</template>
<script>
export default {
    data(){
        return{
        li:{
            title:'',
            content:''
        }    
        }
    },
    methods:{
        fun(){
            this.axios.get('new/by?id='+this.$route.params.id).then((res)=>{this.li=res.data;});
        }
    },
    props:['linew'],
    created(){
        var ll=this.$route.params.id-1
        this.li=this.linew[ll]
        this.fun()
    }
}
</script>
<style scoped>
.gongx{
  padding: 30px;
  border-top: 3px solid rgba(230,0,18,1);
    background:rgba(237,237,237,1);
}
.gongx>h3,.gongx>p{
    text-align: center;
}
.gongx>p{
    margin:35px 0;
}
.title{
        width: 148px;
        height: 45px;
        background: rgba(230,0,18,1);
        color: #fff;
        font-size: 24px;
        text-align: left;
        line-height: 45px;
        padding-left: 29px;
        font-weight: bold;
        position: relative;
}
.title>span{
    display: inline-block;
    width: 70px;
    height: 45px;
    background: #fff;
    right: -53px;
    border-bottom:3px solid rgba(230,0,18,1);
    position: absolute;
    -webkit-transform: skewX(45deg);
    transform: skewX(37deg);
}
</style>
